import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordDiscipline, EmploymentRecordDisciplineSubmit } from '../models/employment-record-discipline.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordDisciplineService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getDisciplines(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Discipline`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            disciplines: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getDiscipline(employeeId: string, employmentRecordId: string, disciplineId: string): Observable<EmploymentRecordDiscipline> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Discipline/${disciplineId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postDiscipline(employeeId: string, employmentRecordId: string, discipline: EmploymentRecordDisciplineSubmit): Observable<EmploymentRecordDiscipline> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Discipline`, discipline, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteDiscipline(employeeId: string, employmentRecordId: string, disciplineId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Discipline/${disciplineId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

